import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as Constants from "../../../../../consts/Constants.js";
import Style from "../../../../../styles/js/StyleCallList.js";
import { CustomCheckbox } from "../../../../../components/common/CustomCheckbox.js";
import Button from "@material-ui/core/Button";
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from '@mui/material/TextField';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from "date-fns/locale/es";

import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmIcon from '@mui/icons-material/Done';

import alerter from "../../../../alerts/alerter"
import Input from "./input";

import { callsErrors } from "../../../../../consts/ErrorMessages.js";
import service from "../../../../../plas/services/calls/service";
import { formatDateDDMMYYYYHHMM } from "../../../../../plas/utils";
import { applicationStates, applicationReplyCodes } from "../../../../../plas/services/calls/models";

export default function AdminApplication( {applicationId} ) {

  const style = Style();
  
  const codeToState = [0, 3, 4];
  const actions = ["Re-abrir", "Aceptar", "Rechazar"]

  const [application, setApplication] = React.useState(null);
  const [updating, setUpdating] = React.useState(false);
  const [askSend, setAskSend] = React.useState(false);
  const [decision, setDecision] = React.useState(0);
  const [comments, setComments] = React.useState(null);
  const [giveExtension, setGiveExtension] = React.useState(false);
  const [newExtensionDate, setNewExtensionDate] = React.useState(new Date());

  const commentChange = (event) => {
    setComments(event.target.value);
  };

  const decisionChange = (event) => {
    setDecision(event.target.value);
  };

  const giveExtensionChange = (event) => {
    setGiveExtension(event.target.checked);
  }

  const extensionDateChange = (value) => {
    setNewExtensionDate(value);
  }

  const getApplication = () => {
    service.api.applications.get(applicationId, (response) => {
      if (response.result != null) {
        setApplication(response.result);
        if (response.result.extensionDate != null) {
          setNewExtensionDate(new Date(response.result.extensionDate));
          setGiveExtension(true);
        }
      } else {
        alerter.showError(response.error);
      }
    });
  }

  const getContent = (input) => {
    var inputContent = null;
    application.contents.forEach(content => {
      if (content.inputId === input.id) {
        inputContent = content
        return;
      }
    });
    return inputContent;
  } 

  const sendReply = () => {
    
    var reply = {
      "code": decision,
      "message": comments,
      "extensionDate": (decision === 0 && giveExtension) ? newExtensionDate.getTime() : null,
    }

    if (reply.extensionDate != null) {
      if (reply.extensionDate < application.call.endDate) {
        alerter.showError({ message: callsErrors.extensionBeforeCallEnd});
        return;
      }
      if (application.extensionDate != null && reply.extensionDate < application.extensionDate) {
        alerter.showError({ message: callsErrors.extensionBeforeCurrent});
        return;
      }
    }

    setUpdating(true);

    service.api.applicationReplies.create(applicationId, reply, (response) => {
      if (response.result != null) {
        application.replies.push(response.result);
        application.state = codeToState[response.result.code];
        if (response.result.extensionDate != null)
          application.extensionDate = response.result.extensionDate;
        application.lastUpdate = response.result.creationTime;
        setComments("");
        setDecision(0);
        setApplication(application);
        setAskSend(false)
      } else { 
        alerter.showError(response.error);
      }

      setUpdating(false);
    });
  }


  React.useEffect(() => {
    getApplication();
  }, []);

  return (
    <div className={style.box} >
      { application != null ?
        (
          <div className={style.row }>
            <Card style={{ marginBottom: "15px"}}>
               <div className={style.itemHeader}>
                <Typography className={style.titleInitial}>
                  { application.call.name } 
                </Typography>
              </div>
              <div style={{ paddingLeft: "12px", paddingRight: "12px", textAlign:"left"}}>
                <div className={style.itemContent}>
                  <Stack style={{marginTop: "10px"}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                    <Stack alignItems="start">
                      <Typography className={style.bodyInitial}>
                       <Typography className={style.bodyInitial}>
                        <span style={{ color: Constants.COLOR_GRAY_DARK }}>ID de Usuario: </span>
                        <span>#{application.userId}</span>
                      </Typography>
                        <span style={{ color: Constants.COLOR_GRAY_DARK }}>Nombre: </span>
                        { application.userProfile != null ?
                          (<span>{application.userProfile.name} {application.userProfile.lastName}</span>)
                          : (<span>Desconocido</span>)
                        }
                      </Typography>
                      { application.userProfile != null && application.userProfile.phoneNumber != null ?
                        (<Typography className={style.bodyInitial}>
                          <span style={{ color: Constants.COLOR_GRAY_DARK }}>Teléfono: </span>
                          <span>{application.userProfile.phoneNumber}</span>
                        </Typography>) : (null)
                      }
                      
                    </Stack>
                    <Stack alignItems="start">
                        <Typography className={style.bodyInitial}>
                          <span style={{ color: Constants.COLOR_GRAY_DARK }}>Código de postulación: </span>
                          <span>#{application.callId}-{application.id}</span>
                        </Typography>
                        <Typography className={style.bodyInitial}>
                          <span style={{ color: Constants.COLOR_GRAY_DARK }}>Apertura de postulación: </span>
                          <span>{formatDateDDMMYYYYHHMM(application.creationTime)}</span>
                        </Typography>
                      </Stack>
                      <Stack alignItems="start">
                        <Typography className={style.bodyInitial} >
                          <span style={{ color: Constants.COLOR_GRAY_DARK }}>Estado: </span>
                          <span> {applicationStates[application.state] + " (" + formatDateDDMMYYYYHHMM(application.lastUpdate) + ")" }</span>
                        </Typography>
                        { application.state === 0 ?
                          (<Typography className={style.bodyInitial} >
                            <span style={{ color: Constants.COLOR_GRAY_DARK }}>Fecha limite de envío: </span>
                            <span> { application.extensionDate !== undefined ? 
                                formatDateDDMMYYYYHHMM(application.extensionDate) + " (prórroga)" :
                                formatDateDDMMYYYYHHMM(application.call.endDate) 
                              }
                            </span>
                          </Typography>) : null
                        }
                    </Stack>
                  </Stack>
                </div>
              </div>
            </Card>

            <Card style={{ marginBottom: "15px"}}>
              <div className={style.itemHeader}>
                <Typography className={style.titleInitial}>
                  Revisiones y comentarios
                </Typography>    
              </div>
              <div style={{ padding: "12px", textAlign: "left"}}>
                <Stack style={{marginTop: "10px"}} divider={<Divider orientation="horizontal" flexItem />} spacing={2}>      
                  { application.replies.length > 0 && application.replies.map((reply) => (
                     <div>
                      <Typography className={style.bodyInitial} >
                        <span style={{fontWeight:"bold"}}>Fecha: </span>
                        <span>{formatDateDDMMYYYYHHMM(reply.creationTime)}</span>
                      </Typography>
                      <Typography className={style.bodyInitial} >
                        <span style={{fontWeight:"bold"}}>Estado de la postulación: </span>
                        <span>{applicationReplyCodes[reply.code]}</span>
                      </Typography>
                      { reply.extensionDate != null ? (
                        <div>
                          <span style={{fontWeight:"bold"}}>Fecha de prórroga: </span>
                          <span>{ formatDateDDMMYYYYHHMM(reply.extensionDate) }</span>                             
                        </div>
                        ) : (null)
                      }
                      <Typography style={{whiteSpace: "pre-line"}} className={style.bodyInitial} >
                        {reply.message}
                      </Typography>
                     </div>
                    ))
                  }
                  { application.call.state === 2 && application.call.result == null ? (
                    <div>
                      <Grid container spacing={1} style={{padding:"0px", margin:"0px", alignItems:"center", height:"56px"}}>
                        <span>Decisión:</span>
                        <Select
                          style={{marginLeft:"8px", width:"110px", textAlign:"left"}}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={decision}
                          label="state"
                          onChange={decisionChange}>
                          <MenuItem value={0}>Re-abrir</MenuItem>
                          <MenuItem value={1}>Aceptar</MenuItem>
                          <MenuItem value={2}>Rechazar</MenuItem>
                        </Select>
                        { decision === 0 ? 
                          (<div style={{ height:"100%", display:"flex", alignItems: "center", justifyContent: "center"}}>
                            <span style={{marginLeft:"32px"}}>Prórroga:</span>
                            <CustomCheckbox 
                              style={{ marginRight:"12px"}}
                              checked={giveExtension}
                              onChange={giveExtensionChange}
                              disableRipple/>
                            { giveExtension ? 
                              (<LocalizationProvider 
                                adapterLocale={esLocale}
                                dateAdapter={AdapterDateFns}>
                                <DateTimePicker
                                  format="dd/MM/yyyy HH:mm"
                                  inputFormat="dd/MM/yyyy HH:mm"
                                  label="Fecha de prórroga"
                                  disabledKeyboardNavigation
                                  value={newExtensionDate}
                                  onChange={extensionDateChange}
                                  renderInput={(params) => <TextField {...params} /> }/>
                                </LocalizationProvider>) 
                              : (null)
                            }
                          </div>) : (null) }
                      </Grid>
                      <div className={style.itemRow} style={{marginTop: "14px"}}>
                         <TextField
                            style={{width:"100%"}}
                            label="Comentarios"
                            multiline
                            value={comments}
                            onChange={commentChange}
                            placeholder="Ingrese aqui comentarios para el postulante. Por ejemplo: 'Se re-abre la postulación porque la foto del DNI no se ve bien, por favor subir una mejor imagen y re-enviar postulación.'"
                          />
                      </div>
                      <div className={style.itemRow} style={{ textAlign:"right", marginTop: "14px"}}>
                        <LoadingButton
                          style={{background: Constants.COLOR_PRIMARY, color: 'white' }}
                          loading={updating}
                          loadingPosition="start"
                          startIcon={<SendIcon />}
                          variant="contained"
                          onClick={ () => { setAskSend(true) }}>
                          <b>Enviar devolución</b>
                        </LoadingButton>
                      </div>
                    </div>) :(null)
                  }
                </Stack>
              </div>
            </Card>

            { application.call.configuration.inputs.map((input) => (
                <Input application={application} inputData={ input } contentData={ getContent(input) }/>
              ))
            }

          </div>
        )
        :
        null
      }

      <Dialog
        open={askSend}
        onClose={ () => { if (!updating) setAskSend(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle>
          ¿Enviar decisión?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            El postulante recibira una notificación sobre la decisión tomada y los comentarios incluidos en dicha devolución.
            <Typography className={style.bodyInitial} style={{marginTop:"8px"}}>
              <span style={{fontWeight:"bold"}}>Decisión: </span>
              <span>{actions[decision]}</span>
            </Typography>
            { decision === 0 && giveExtension && newExtensionDate != null ? (
                <div>
                  <span style={{fontWeight:"bold"}}>Fecha de prórroga: </span>
                  <span>{ formatDateDDMMYYYYHHMM(newExtensionDate) }</span>                             
                </div>
              ) : (null)
            }
            <Typography style={{whiteSpace: "pre-line"}} className={style.bodyInitial} >
              {comments}
            </Typography>
        </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            style={{background: Constants.COLOR_GRAY, color: 'white' }}
            variant="contained"
            disabled={updating}
            startIcon={<CancelIcon />}
            onClick={ () => { setAskSend(false) } }>
            Cancelar
          </Button>
          <LoadingButton
            style={{background: Constants.COLOR_PRIMARY, color: 'white' }}
            loading={updating}
            loadingPosition="start"
            startIcon={<ConfirmIcon />}
            variant="contained"
            onClick={ () => { sendReply() }}>
            <b>Confirmar</b>
          </LoadingButton>
        </DialogActions>
      </Dialog>

    </div>

  );
}
